import { BASE_URL } from 'consts';

const getBookBulkEndpointUrl = (brandId: string) =>
  `${BASE_URL}/v1/brands/${brandId}/book-bulk`;

export default getBookBulkEndpointUrl;
